
const initialState = {
  rid: "0",
  type: "",
  name: ""
}


function currentObject(state = initialState, action) {
    return state; 
  }


export default currentObject